import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./i18n";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Suspense fallback={<div className="p-8 text-center">…</div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
